module.exports = __webpack_public_path__ + "static/preview-kardiolog-ff4de5a9ee7f3710d498762e7b1888f3.png";